@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;

@use 'sass:color';

$time-picker-width: 98px;
$var-content-padding-bottom: 65px;
$created-at-width: 72px;
$duration-width: 48px;
$var-connector-line-width: 2px;
$var-connector-line-offset: 5px;
$var-strike-line-width: 1px;
$opaque-opacity: 0.3;

.time-sheet-bulk-edit-modal {
	&__title-opaque {
		opacity: $opaque-opacity;
	}

	&__footer-opaque {
		opacity: $opaque-opacity;
	}

	.modal-content {
		// this is equal to the .modal-content's max-height so it prevents height changes while changing tabs
		min-height: 65vh;
		overflow-y: hidden;
		padding-bottom: $var-content-padding-bottom;
	}

	.modal-footer {
		position: absolute;
		left: 0;
		right: 0;
	}

	&__body {
		flex: 1;
	}

	&__loading {
		text-align: center;
		margin-top: Constants.$val-spacing-l;
	}

	&__information {
		.row {
			padding-left: 0;
			padding-right: 0;
		}

		&__last-signature-date {
			margin-left: Constants.$val-spacing-s;
		}
	}

	&__timeline {
		min-height: 10vh;
		display: flex;
		flex-direction: column;

		&__entries {
			margin-top: Constants.$val-spacing-m;
		}

		&__manual-title {
			font-size: Constants.$val-fontSizeBig;
			line-height: Constants.$val-lineHeightBig;
			font-weight: 700;
			margin-top: Constants.$val-spacing-l;
		}

		&__total-times {
			background-color: Colors.$col-white;
			color: Colors.$col-darkBlueBorder;
			font-size: Constants.$val-fontSizeRegular;
			font-weight: bold;
			padding: Constants.$val-spacing-s Constants.$val-spacing-m;
			margin: 0px (- Constants.$val-spacing-l) 0px (- Constants.$val-spacing-l);

			&__row {
				display: flex;
				justify-content: space-between;

				&__work-type {
					display: flex;
					align-items: center;
					margin-top: Constants.$val-spacing-s;
					padding-right: Constants.$val-spacing-s;
					font-weight: 400;

					> span {
						font-size: Constants.$val-fontSizeXBig;
						margin-right: Constants.$val-spacing-s;
					}
				}
			}

			&--opaque {
				opacity: $opaque-opacity;
			}
		}

		&__total-times-overlap {
			background-color: Colors.$col-canceledRed;
			color: Colors.$col-white;
			font-size: Constants.$val-fontSizeRegular;
			font-weight: bold;
			padding: Constants.$val-spacing-m Constants.$val-spacing-m;
			margin: 0px (- Constants.$val-spacing-l) 0px (- Constants.$val-spacing-l);

			&--opaque {
				opacity: $opaque-opacity;
			}
		}

		&__rejection-banner {
			background-color: Colors.$col-canceledRed;
			color: Colors.$col-white;
			margin: Constants.$val-spacing-l (- Constants.$val-spacing-l) 0px (- Constants.$val-spacing-l);
			padding: Constants.$val-spacing-s Constants.$val-spacing-m;
			font-size: Constants.$val-fontSizeSmall;

			&__user {
				font-weight: bold;
			}

			&__reason-title {
				font-weight: bold;
			}

			&__info {
				margin-left: Constants.$val-spacing-xs;
			}

			&--opaque {
				opacity: $opaque-opacity;
			}
		}

		&__new-entry {
			background-color: Colors.$col-orangeBackground;
			padding: Constants.$val-spacing-s;
			border-radius: Constants.$val-spacing-s;
			margin-top: Constants.$val-spacing-m;

			&__icon {
				font-size: Constants.$val-fontSizeXBig;
				color: Colors.$col-greyMid;
			}

			&__input-field {
				width: auto;
				background-color: Colors.$col-white;
			}

			&__input-wrapper {
				margin-bottom: 0;
			}

			&__minus-sign {
				font-size: Constants.$val-fontSizeXBig;
				display: flex;
				align-items: center;
			}

			&__close {
				cursor: pointer;
			}

			&__total {
				font-weight: bold;
			}
		}

		&__edit-entry {
			&__delete-container {
				display: flex;
				justify-content: left;
				align-items: center;
			}

			&__delete {
				cursor: pointer;
				color: Colors.$col-blue;

				&__text {
					margin-left: Constants.$val-spacing-m;
				}
			}
		}

		&--empty {
			display: flex;
			padding: Constants.$val-spacing-l;
			font-size: Constants.$val-fontSizeSmall;
			color: Colors.$col-greyMid;
		}
	}

	&__time-sheet-gap {
		background: Colors.$col-orange;
		color: Colors.$col-white;
		font-weight: bold;
		margin-top: Constants.$val-spacing-m;
		display: flex;
		align-items: center;
		padding: Constants.$val-spacing-s Constants.$val-spacing-l;
		font-size: Constants.$val-fontSizeSmall;
		line-height: Constants.$val-fontSizeSmall;
		border-radius: Constants.$val-borderRadius;

		.icon-info {
			margin-right: Constants.$val-spacing-s;
			font-size: Constants.$val-fontSizeRegular;
		}

		&--opaque {
			opacity: $opaque-opacity;
		}

		&--editable {
			cursor: pointer;
		}
	}

	&__time-sheet-occupied {
		background: Colors.$col-greyFontLight;
		color: Colors.$col-white;
		font-weight: bold;
		margin-top: Constants.$val-spacing-m;
		display: flex;
		padding: Constants.$val-spacing-s Constants.$val-spacing-l;
		font-size: Constants.$val-fontSizeSmall;
		line-height: Constants.$val-lineHeightSmall;
		border-radius: Constants.$val-borderRadius;

		&--opaque {
			opacity: $opaque-opacity;
		}
	}

	&__time-sheet-entry {
		margin-top: Constants.$val-spacing-s;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: Constants.$val-spacing-s Constants.$val-spacing-m;
		position: relative;

		&__connection {
			display: none;
		}

		& + & {
			.time-sheet-edit-modal__time-sheet-entry__connection {
				display: block;
				position: absolute;
				bottom: 40px;
				left: Constants.$val-spacing-xl - $var-connector-line-offset;
				width: $var-connector-line-width;
				height: Constants.$val-spacing-l;
				background-color: Colors.$col-greyConnection;

				&--overlap {
					background: Colors.$col-red;
				}
			}
		}

		&--opaque {
			opacity: $opaque-opacity;
		}

		&--newly-added {
			animation: newly-added 2000ms normal;
		}

		@keyframes newly-added {
			0% {
				background: Colors.$col-blueBackground;
			}

			100% {
				background: color.scale(Colors.$col-blueBackground, $lightness: 100%);
			}
		}

		&__work-type-icon {
			font-size: Constants.$val-fontSizeXBig;
			color: Colors.$col-darkBlueBorder;
			margin-right: Constants.$val-spacing-l;

			&--inactive {
				color: Colors.$col-greyMid;
			}
		}

		&__start-date {
			display: flex;
			justify-content: center;
			white-space: nowrap;
		}

		&__work-type-label {
			font-size: Constants.$val-fontSizeRegular;
			color: Colors.$col-greyDark;
			font-weight: bold;
			margin-left: Constants.$val-spacing-s;

			&--inactive {
				color: Colors.$col-greyMid;
			}
		}

		&__time {
			font-weight: bold;

			&--inactive {
				color: Colors.$col-greyMid;
			}

			&--unsigned-manual {
				color: Colors.$col-greyDark;
			}

			&--overlap {
				color: Colors.$col-red;
			}
		}

		&__time-separator {
			margin: 0 Constants.$val-spacing-m;

			&--inactive {
				color: Colors.$col-greyMid;
			}
		}

		&__duration {
			font-size: Constants.$val-fontSizeRegular;
			margin-left: Constants.$val-spacing-xl;

			&--inactive {
				color: Colors.$col-greyMid;
			}
		}

		&__activity-toggle-icon {
			cursor: pointer;
			font-size: Constants.$val-fontSizeRegular;
			margin-left: Constants.$val-spacing-m;
		}

		&__fields {
			display: flex;
			flex-direction: row;
			align-items: center;

			.form-group {
				margin: 0;
			}
		}

		&__work-type-icon {
			color: Colors.$col-darkBlueBorder;
			font-size: Constants.$val-fontSizeBig;
			line-height: Constants.$val-fieldSize;
			margin-right: Constants.$val-spacing-m;

			&--unsigned-manual {
				color: Colors.$col-darkBlueBorder;
			}

			&--overlap {
				color: Colors.$col-red;
			}
		}

		&__delete-icon {
			font-size: Constants.$val-fontSizeBig;
			line-height: Constants.$val-fieldSize;
			margin-left: Constants.$val-spacing-m;
			cursor: pointer;
		}

		&__created-at {
			flex: 1;
			margin-left: Constants.$val-spacing-s;
			min-width: $created-at-width;
			justify-content: center;
			align-items: flex-start;
			display: flex;
			flex-direction: column;
			font-size: Constants.$val-fontSizeSmall;
		}

		&__time-picker {
			width: $time-picker-width;
			min-width: $time-picker-width;
		}

		&__time,
		&__time-separator {
			font-size: Constants.$val-fontSizeRegular;
			line-height: Constants.$val-fieldSize;
			display: flex;
			justify-content: center;
		}

		&__time-separator {
			margin: 0 Constants.$val-spacing-s;
		}

		&__duration {
			font-size: Constants.$val-fontSizeRegular;
			line-height: Constants.$val-fieldSize;
			margin-left: Constants.$val-spacing-m;
			white-space: nowrap;
			width: $duration-width;
			min-width: $duration-width;
		}

		.help-block {
			justify-content: flex-end;
		}
	}

	&__time-splits {
		&__total-time {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			padding: Constants.$val-spacing-m Constants.$val-spacing-l;
			background-color: Colors.$col-greyLight;
			font-weight: bold;
			font-size: Constants.$val-fontSizeRegular;
			margin-bottom: Constants.$val-spacing-l;
		}
	}

	&__add-button {
		display: flex;
		color: Colors.$col-darkBlueBorder;
		cursor: pointer;
		font-size: Constants.$val-fontSizeRegular;
		margin-bottom: Constants.$val-spacing-l;
		margin-left: (- Constants.$val-spacing-l);
		padding-left: Constants.$val-spacing-xl;

		&__add-icon {
			font-size: Constants.$val-fontSizeBig;
			margin-right: Constants.$val-spacing-s;
			position: relative;
			top: 2px;
		}
		&__spacing-top {
			margin-top: Constants.$val-spacing-l;
		}

		&--spacing-top {
			margin-top: Constants.$val-spacing-l;
		}
	}

	&__access_label {
		display: flex;
		align-items: center;

		.icon-check {
			margin-right: Constants.$val-spacing-s;
		}
	}

	&__bulk-modal-row {
		margin-bottom: Constants.$val-spacing-m;

		&__user-name {
			display: flex;
			flex-direction: row;
			text-transform: uppercase;
			font-weight: bold;
			font-size: Constants.$val-fontSizeXBig;
			margin: (- Constants.$val-spacing-m);
			margin-bottom: Constants.$val-spacing-s;
			padding: Constants.$val-spacing-s;
			padding-top: Constants.$val-spacing-l;

			&--opaque {
				opacity: $opaque-opacity;
			}
		}
		&:not(:first-child) {
			&:before {
				content: '';
				width: 100%;
				border-top: solid 2px Colors.$col-greyConnection;
				padding-bottom: Constants.$val-spacing-xl;
				position: absolute;
				left: 0;
			}
		}


		
	}

}

.user-full-name{
	margin-right: Constants.$val-spacing-m;
}

.user-per-diem{
	display: flex;
	flex-direction: row;

	.per-diem-amount{
		display: flex;
		flex-direction: row;
		margin-left: Constants.$val-spacing-m;
		align-items: baseline;
		font-weight: normal;

		.per-diem-amount-text{
			font-size: Constants.$val-fontSizeRegular;
			text-transform: none;
			margin-left: Constants.$val-spacing-s;
		}
	}

	.per-diem-amount-input-field {
		border: 1px solid Colors.$col-greyMid;
		border-radius: Constants.$val-borderRadius;
		background-color: Colors.$col-white;
		font-size: Constants.$val-fontSizeRegular;
		line-height: Constants.$val-lineHeightRegular;
		outline: none;
	}

	.per-diem-readonly {
		font-size: Constants.$val-fontSizeRegular;
		margin-top: auto;
		margin-bottom: auto;
		font-weight: normal;

		&__text{
			color: Colors.$color-green;
			font-weight: bold;
			margin-right: Constants.$val-spacing-xs;
		}
	}
}

.time-allocations {
	padding-bottom: Constants.$val-spacing-m;


	&--opaque {
		opacity: $opaque-opacity;
	}

	&__time-allocation-list {
		margin: 0px (- Constants.$val-spacing-m) 0px (- Constants.$val-spacing-m);
		padding: Constants.$val-spacing-s;

		
		&__row {
			margin: 0 (- Constants.$val-spacing-l) 0 (- Constants.$val-spacing-l) ;
	
			&__work-type-input-field {
				width: auto;
				background-color: Colors.$col-white;
			}

			&__work-type-icon {
				color: Colors.$col-black;
				font-size: Constants.$val-fontSizeBig;
				vertical-align: bottom;
			}

			&__text-allocate-to {
				color: Colors.$col-black;
				font-size: Constants.$val-fontSizeRegular;
				text-align: center;
				vertical-align: bottom;
				line-height: Constants.$val-fieldSize;
			}

			&__delete-button {
				margin-top: Constants.$val-spacing-s;
				cursor: pointer;
			}

			&__work-request-option {
				display: flex;
				flex-direction: row;
				align-items: center;

				& > div {
					margin-top: Constants.$val-spacing-xs;
				}
			}
		}
	}

	&__add-allocation {
		margin: 0px (- Constants.$val-spacing-l) 0px (- Constants.$val-spacing-l);
		padding-left: Constants.$val-spacing-xl;
	}

	&--loading {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: Constants.$val-spacing-l;
	}

	&__allocation-time-warning {
		display: flex;
		background-color: Colors.$col-canceledRed;
		padding-left: Constants.$val-spacing-s;
		margin: 0px (- Constants.$val-spacing-l) 0px (- Constants.$val-spacing-l);
		color: Colors.$col-white;
		font-weight: bold;
		font-size: Constants.$val-fontSizeSmall;

		&>span {
			margin-right: Constants.$val-spacing-s;
			font-size: Constants.$val-fontSizeBig;
		}
	}

	&__remove-button {
		color: Colors.$col-darkBlueBorder;
		cursor: pointer;
		font-size: Constants.$val-fontSizeRegular;
		line-height: Constants.$val-fieldSize;

		&__remove-icon {
			font-size: Constants.$val-fontSizeBig;
			margin-right: Constants.$val-spacing-s;
			position: relative;
			top: 2px;
		}
	}

	&__title {
		background-color: Colors.$col-white;
		color: Colors.$col-darkBlueBorder;
		font-size: Constants.$val-fontSizeRegular;
		font-weight: bold;
		padding: Constants.$val-spacing-s Constants.$val-spacing-m;
		margin: 0px (- Constants.$val-spacing-l) 0px (- Constants.$val-spacing-l);
	}
	
}

.cert-status {
	width: fit-content;
	margin-right: Constants.$val-spacing-s;
}

.cert-status-element {
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
}

.cert-status-block {
	display: flex;
	align-items: center;
}

